import { useEffect, useState } from "react";
import { axiosInstance } from "../services/v2/axiosInstance";

/**
 * Fotos de perfil del personal ({userId: url}) para WappTeam (Esteban, 2026-10-10: "debería mostrar la foto de perfil,
 * como Cliq"). Una consulta por pestaña, se renueva cada 10 minutos. Sin foto: las iniciales de siempre.
 */
type Mapa = { [userId: number]: string };
let mapa: Mapa = {};
let cargadoEn = 0;
let pidiendo: Promise<void> | null = null;
const oyentes = new Set<(m: Mapa) => void>();

const cargar = (): Promise<void> => {
	if (pidiendo) return pidiendo;
	pidiendo = axiosInstance.get("/app/_fotos").then((r) => {
		mapa = r.data?.fotos || {};
		cargadoEn = Date.now();
		oyentes.forEach((fn) => fn(mapa));
	}).catch(() => { cargadoEn = Date.now(); }).finally(() => { pidiendo = null; });
	return pidiendo;
};

export const useFotos = (): Mapa => {
	const [m, setM] = useState<Mapa>(mapa);
	useEffect(() => {
		oyentes.add(setM);
		if (Date.now() - cargadoEn > 600000) cargar();
		return () => { oyentes.delete(setM); };
	}, []);
	return m;
};
